import { Field, Form, Formik } from 'formik'
import { Button, Grid } from '@material-ui/core'
import { TextField } from 'formik-material-ui'
import { metodoPrograma } from '../../components/api'

export const Cadastro = ({ objeto, voltar }) => {
  const initialValues = {
    idCategoria: objeto?.[0] || undefined,
    dsNome: objeto?.[1] || undefined,
    dsIcone: objeto?.[2] || undefined,
    nrOrdem: objeto?.[3] || undefined,
    dtExclusao: objeto?.[4] || undefined,
    dsNomeEN: objeto?.[5] || undefined,
    dsNomePT: objeto?.[6] || undefined,
  }

  const salva = async (values) => {
    const dados = {
      idCategoria: values.idCategoria,
      dsNome: JSON.stringify({ 'PT': values.dsNomePT, 'EN': values.dsNomeEN }),
      dsIcone: values.dsIcone,
      nrOrdem: values.nrOrdem,
      dtExclusao: values.dtExclusao
    }
    const res = await metodoPrograma( 'salva', dados )
    if (res.status) voltar()
  }
  
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, setFieldValue, submitForm }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="dsNomeEN"
                label="Name English"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="dsNomePT"
                label="Name Portuguese"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={4}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="dsIcone"
                label="Icon"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={4}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="nrOrdem"
                label="Order"
                type="number"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={4}>
              <Field
                InputLabelProps={{ shrink: true }}
                disabled={true}
                component={TextField}
                name="dtExclusao"
                label="Exclusion"
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Save
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}
